<template>
  <div id="FiltrosDeBusqueda_div">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
      <h5>{{tituloDeBusqueda}}</h5>
      <button v-if="accionCancelar != null || accionCancelar != undefined" class="btn-sm btn-primary btn-buscar" id="realizarFiltrosBusqueda_btn_cancelar" @click='accionCancelar.funcion'><i class="fas fa-window-close"></i></button>
    </div>
    <hr class="mt-1" />    
    <div class="row">
    <div v-if="AccionesMostrar.devolver" class="col-12">
      <h3>Datos del rubro</h3>
      <hr class="mt-1" />    
    </div>
    <div v-for="catalogo in catalogos" :key="catalogo.catalogoId" class="col-12">     
      <div v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null">
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales && (AccionesPago.alta || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver)" id="PartidosJudiciales_div">
          <h6>Partido Judicial</h6>
          <C009PartidosJudiciales 
              :class="[parametros_PartidoJudicial.esInformativo ? 'catalogoInformativo' : '']" 
              v-on:valorParaElPadre="cambioDePartidoJudicialEvento" 
              v-on:valorParaElPadrePrimerElemento="cambioDePartidoJudicial"
              :prefijo="catalogo.etiquetaDeHtml" 
              :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"
              :idDelInput="catalogo.idDelInput" 
              :parametros="parametros_PartidoJudicial.parametros" 
              :valorDefinido="parametros_PartidoJudicial.partidoJudicialId" 
              :key="parametros_PartidoJudicial.key">
          </C009PartidosJudiciales>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Juzgados && (AccionesPago.alta || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver)" id="Juzgados_div">
          <h6>Juzgado</h6>
          <C001Area 
            :class="[parametros_Area.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeAreaEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeArea"
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"  
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Area.parametros" 
            :valorDefinido="parametros_Area.areaId" 
            :key="parametros_Area.key">
          </C001Area>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Materias && (AccionesPago.alta || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver)" id="Materias_div">
          <h6>Materia</h6>
          <C002Materias 
            :class="[parametros_Materia.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeMateriaEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeMateria" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Materia.parametros" 
            :valorDefinido="parametros_Materia.materiaId" 
            :key="parametros_Materia.key">
          </C002Materias>
        </div>                
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Delitos"  id="Delitos_div">
          <h6>Delito</h6>
          <C008Delitos 
            :class="[parametros_Delito.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeDelitoEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeDelito" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Delito.parametros" 
            :valorDefinido="parametros_Delito.delitoId" 
            :key="parametros_Delito.key">
          </C008Delitos>
        </div>
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Rubros && (AccionesPago.alta || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver)"  id="Rubros_div">
          <h6>Concepto</h6>
          <C006TiposRubro 
            :class="[parametros_Rubro.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeRubroEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeRubro" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Rubro.parametros" 
            :valorDefinido="parametros_Rubro.rubroId" 
            :key="parametros_Rubro.key"
            :quitarRubros="quitarRubros">
          </C006TiposRubro>
        </div>
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Bancos && (AccionesMostrar.devolver)"  id="Bancos_div">
          <h6>Banco</h6>
          <C019TiposBanco 
            :class="[parametros_Banco.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeBancoEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeBanco" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Banco.parametros" 
            :valorDefinido="parametros_Banco.bancoId" 
            :key="parametros_Banco.key"
            >
          </C019TiposBanco>
        </div> 
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.TiposDeDocumentos && (AccionesPago.alta || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver)/*&& (parametros_Materia.materiaId > 0 || AccionesMostrar.consulta)*/" id="TiposDeDocumentos_div">
          <h6>Tipo de documento</h6>
          <C004TiposDocumento 
          :class="[parametros_TipoDocumento.esInformativo ? 'catalogoInformativo' : '']" 
          v-on:valorParaElPadre="cambioDeTipoDeDocumento" 
          :prefijo="catalogo.etiquetaDeHtml" 
          :tipo="catalogo.tipoDeSelect" 
          :idDelInput="catalogo.idDelInput" 
          :parametros="parametros_TipoDocumento.parametros" 
          :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" 
          :key="parametros_TipoDocumento.key"></C004TiposDocumento>
        </div>     


        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (parametros_TipoDocumento.tipoDocumentoId > 0 /*|| AccionesMostrar.consulta*/)" id="Consecutivo_div">
          <h6>Consecutivo</h6>
          <input class="form-control" type="text" placeholder="####/####" v-model="consecutivo" id="Consecutivo" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeConsecutivo($event)" v-mask="'####/####'" autocomplete="off"/>
        </div>
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (parametros_TipoDocumento.tipoDocumentoId > 0 /*|| AccionesMostrar.consulta*/) && !(AccionesPago.alta || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver)" id="CarpetaDeEjecucion_div">
          <h6>Carpeta de Ejecucion</h6>
          <input class="form-control" type="text" placeholder="####/####" v-model="carpetadeejecucion" id="CarpetaDeEjecucion" v-mask="'####/####'" autocomplete="off"/>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (consecutivo && consecutivo.length == 9)">
          <h6>Número romano</h6>
          <input type="text" id="numeroRomano" v-model="numeroRomano" class="form-control" v-mask="'AAA'" placeholder="Numero Romano" @input="(val) => (numeroRomano = numeroRomano.toUpperCase())" @keypress="esRomano($event)"/>
        </div>
        <!-- <div class="form-group" v-if="mostrarNumeroExtra && catalogo.catalogoId == enumeraciones.catalogos.NumeroExtra && parametros_TipoDocumento.tipoDocumentoId > 0 && AccionesPago.alta" id="NumeroExtra_div">
          <h6>Número</h6>
          <input class="form-control" type="text" placeholder="##" v-model="numeroExtra" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeNumeroExtra($event)" v-mask="'##'" />
        </div>  --> 
      </div>
    </div>


    <div v-if="AccionesPago.alta || AccionesPago.agregar || AccionesPago.editar || AccionesMostrar.devolver" class="col-12 form-group" id="monto_div" >
          <h6>Monto {{(AccionesMostrar.devolver) ? '($' + this.totalPagar +  ') (Total devuelto: $' + totalDevuelto +')' : ''}}</h6>
          <input class="form-control" type="number" placeholder="$0.00" min="0" @wheel="$event.target.blur()" v-model="monto" id="monto" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent @keypress="esMonto($event)" /><!--checar campos sin autocompletar y sin ctrl v-->
    </div>  
    <div v-if="AccionesPago.alta || AccionesPago.agregar || AccionesPago.editar && (!AccionesMostrar.devolver)" class="col-12 form-group" id="persona_div" @change="esPortador($event)">
          <h6>Al portador</h6><input type="checkbox" id="persona" v-model="persona"  >
          
    </div>

    
    <div class="col-12 form-group" id="nombre_div" v-if="!persona">     
          <h6>Nombre(s)</h6>
          <input class="form-control persona" type="text" placeholder="Ingrese el nombre" v-model="nombre" id="nombre" @input="(val) => (nombre = nombre.toUpperCase())" @keypress="esLetra($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    </div>
    <div class="col-12 form-group" id="apellido_paterno_div" v-if="!persona">
          <h6>Apellido Paterno</h6>
          <input class="form-control persona" type="text" placeholder="Ingrese el apellido paterno" v-model="apellido_paterno" id="apellido_paterno" @input="(val) => (apellido_paterno = apellido_paterno.toUpperCase())" @keypress="esLetra($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    </div>
    <div class="col-12 form-group" id="apellido_materno_div" v-if="!persona">
          <h6>Apellido Materno</h6>
          <input class="form-control persona" type="text" placeholder="Ingrese el apellido materno" v-model="apellido_materno" id="apellido_materno" @input="(val) => (apellido_materno = apellido_materno.toUpperCase())" @keypress="esLetra($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    </div> 

    <div v-if="AccionesMostrar.buscar" class="col-12 form-group" id="folio_div">
          <h6>Folio</h6>
          <input class="form-control" type="text" placeholder="Ingrese el folio" v-model="folioBusqueda" id="folio" @keypress="esNumero($event)"  @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    </div>

    <div v-if="AccionesMostrar.buscar" class="col-12 form-group" id="fechasi_div">
          <h6>Fecha</h6><input type="checkbox" id="fechasi" v-model="fechasi" @click="fechaCheckbox" >
    </div>
    <div v-if="AccionesMostrar.buscar && fechasi" class="col-12 form-group" id="fecha_div">
          <input class="form-control" type="date"  v-model="fecha" id="fecha" :max="fechaMaxima" 
          @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    </div>


    <div v-if="AccionesPago.alta || AccionesPago.editar || AccionesPago.agregar" class="col-12 form-group" id="telefono_div">
          <h6>Telefono</h6>
          <input class="form-control" type="text" placeholder="Ingrese el telefono" v-model="telefono" id="telefono" @keypress="esNumero($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    </div>

    <div v-if="AccionesPago.alta || AccionesPago.editar || AccionesPago.agregar && (!AccionesMostrar.devolver)" class="col-12 form-group" @change="observacionRubro($event)" id="observaciones_div">
      <h6>Observaciones</h6><input type="checkbox" id="observacionescheck" v-model="observacionescheck">
    </div>
    <div class="col-12 form-group" id="observaciones_div" v-if="observacionescheck">
      <input class="form-control" type="text" placeholder="Observaciones" v-model="observaciones" id="observaciones"  @input="(val) => (observaciones = observaciones.toUpperCase())" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" />
    </div>

    </div>
    <hr class="mt-1" />
    <div v-if="AccionesMostrar.devolver" class="row">
      <div class="col-12 form-group">
        <h3>Datos del oficio</h3>
        <hr class="mt-1" />    
      </div>
      <div class="col-12 form-group" id="numero_oficio_juzgado_div">
          <h6>No. de Oficio del Juzgado</h6>
          <input class="form-control" type="text" id="numeroOficioJuzgado" v-model="parametros_Oficio.numeroOficioJuzgado" @input="(val) => (parametros_Oficio.numeroOficioJuzgado = parametros_Oficio.numeroOficioJuzgado.toUpperCase())" @keypress="esNumeroOficio($event)" autocomplete="off"  placeholder="####/####" maxlength = "10">
      </div>
      <div class="col-12 form-group" @change="juzgadoDestinatario($event)" id="checkJuzgadoDestinatario_div">
        <h6>Juzgado Destinatario Ejecucion</h6><input type="checkbox" id="checkJuzgadoDestinatario" v-model="checkJuzgadoDestinatario">
      </div>
      <div class="col-12 form-group" id="cheque_div">
          <h6>No. de Cheque</h6>
          <input class="form-control" type="text" id="cheque" v-model="parametros_Oficio.cheque" autocomplete="off" @keypress="esNumero($event)" placeholder="Ingrese Numero de Cheque">
      </div>
      <div class="col-12 form-group" id="numero_oficio_oficialia_div">
          <h6>No. de Oficio de Oficialia</h6>
          <input class="form-control" type="text" id="numeroOficioOficialia" v-model="parametros_Oficio.numeroOficioOficialia" v-mask="'####-####'" @input="(val) => (parametros_Oficio.numeroOficioOficialia = parametros_Oficio.numeroOficioOficialia.toUpperCase())" autocomplete="off" placeholder="####-####">
      </div>

      <div class="col-12" id="PuestosRemitente_div">
          <h6>Puesto Remitente</h6>
          <C045Puestos
              :class="[parametros_PuestoRemitente.esInformativo ? 'catalogoInformativo' : '']"
              v-on:valorParaElPadre="cambioDePuestoRemitenteEvento"
              v-on:valorParaElPadrePrimerElemento="cambioDePuestoRemitente"
              :prefijo="enumeraciones.etiquetasDeHTML.Select" 
              :tipo="enumeraciones.tiposDeSelect.Seleccione" 
              :parametros="parametros_PuestoRemitente.parametros"
              :valorDefinido="parametros_PuestoRemitente.puestoId"
              :key="parametros_PuestoRemitente.key"
            ></C045Puestos> 
      </div>

      <div class="col-12 " id="TituloDestinatario_div">
        <h6>Titulo Remitente</h6>
        <C027TiposTitulo
            :class="[parametros_TituloRemitente.esInformativo ? 'catalogoInformativo' : '']"
              v-on:valorParaElPadre="cambioDeTituloRemitenteEvento"
              v-on:valorParaElPadrePrimerElemento="cambioDeTituloRemitente"
              :prefijo="enumeraciones.etiquetasDeHTML.Select" 
              :tipo="enumeraciones.tiposDeSelect.Seleccione" 
              :parametros="parametros_TituloRemitente.parametros"
              :valorDefinido="parametros_TituloRemitente.tituloId"
              :key="parametros_TituloRemitente.key"
        ></C027TiposTitulo>
      </div>

      <div class="col-12 form-group" id="nombre_remitente_div">
          <h6>Nombre Remitente</h6>
          <input class="form-control" type="text" id="nombreRemitente" v-model="parametros_Oficio.nombreRemitente" @input="(val) => (parametros_Oficio.nombreRemitente = parametros_Oficio.nombreRemitente.toUpperCase())" @keypress="esLetraOficio($event)" placeholder="Nombre Completo del Remitente">
      </div>

      <div class="col-12 " id="PuestosDestinatario_div">
        <h6>Puesto Destinatario</h6>
        <C045Puestos
            :class="[parametros_PuestoDestinatario.esInformativo ? 'catalogoInformativo' : '']"
              v-on:valorParaElPadre="cambioDePuestoDestinatarioEvento"
              v-on:valorParaElPadrePrimerElemento="cambioDePuestoDestinatario"
              :prefijo="enumeraciones.etiquetasDeHTML.Select" 
              :tipo="enumeraciones.tiposDeSelect.Seleccione" 
              :parametros="parametros_PuestoDestinatario.parametros"
              :valorDefinido="parametros_PuestoDestinatario.puestoId"
              :key="parametros_PuestoDestinatario.key"
        ></C045Puestos>
      </div>

      <div class="col-12 " id="TituloDestinatario_div">
        <h6>Titulo Destinatario</h6>
        <C027TiposTitulo
            :class="[parametros_TituloDestinatario.esInformativo ? 'catalogoInformativo' : '']"
              v-on:valorParaElPadre="cambioDeTituloDestinatarioEvento"
              v-on:valorParaElPadrePrimerElemento="cambioDeTituloDestinatario"
              :prefijo="enumeraciones.etiquetasDeHTML.Select" 
              :tipo="enumeraciones.tiposDeSelect.Seleccione" 
              :parametros="parametros_TituloDestinatario.parametros"
              :valorDefinido="parametros_TituloDestinatario.tituloId"
              :key="parametros_TituloDestinatario.key"
        ></C027TiposTitulo>
      </div>

      <div class="col-12 form-group" id="nombre_destinatario_div">
          <h6>Nombre Destinatario</h6>
          <input class="form-control" type="text" id="nombreDestinatario" v-model="parametros_Oficio.nombreDestinatario" @input="(val) => (parametros_Oficio.nombreDestinatario = parametros_Oficio.nombreDestinatario.toUpperCase())" @keypress="esLetraOficio($event)" placeholder="Nombre Completo del Destinatario">
      </div>

      <div class="col-12 form-group" id="fechaDevolucion_div">
          <h6>Fecha de Devolucion</h6><input class="form-control" type="date"  v-model="fechaDevolucion" id="fechaDevolucion" :max="fechaMaxima" 
          @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
      </div>

      <div class="col-12 form-group" @change="observacionDevolucion($event)" id="observacionesdevolucion_div">
        <h6>Observaciones</h6><input type="checkbox" id="observacionesdevolucioncheck" v-model="observacionesdevolucioncheck">
      </div>
      <div class="col-12 form-group" id="observacionesdevolucion_div" v-if="observacionesdevolucioncheck">
        <input class="form-control" type="text" placeholder="Observaciones" v-model="observacionesdevolucion" id="observacionesdevolucion"  @keyup.enter='ejecutaLaFuncion()' autocomplete="off" />
      </div>



     </div>




    <div id="RealizarFiltrosBusqueda_div" class="d-flex row justify-content-between">
      <div v-if="!AccionesPago.editar && !AccionesMostrar.devolver && !AccionesPago.agregar" class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1 text-left">          
          <button class="btn btn-primary overwrapDeBotones p-2 btn-buscar" @click="limpiarFiltros(); " id="limpiar"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Formulario</button>
      </div>

      <div v-if="AccionesMostrar.buscar" class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1 text-right">
          <button class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-search fa-lg"></i>&nbsp;&nbsp;Buscar</button>          
      </div>
      <div v-if="AccionesMostrar.guardar || AccionesMostrar.editar || AccionesPago.agregar || AccionesMostrar.devolver" class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1">
          <button class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosGuardar_btn" @click='ejecutaLaFuncion()'><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>          
      </div>

      <div v-if="AccionesMostrar.editar || AccionesPago.editar || AccionesMostrar.devolver" class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1 text-right">
          <button class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosCancelar_btn" @click='cancelar()'><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>          
      </div>  
      
    </div>    
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from "@/../static/js/comun"
  import { mapActions } from 'vuex'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import func from './Funciones/comun.js'


  Vue.use(VueMask);



  export default {

    directives: {
        tooltipF
    },
    data() {
      return {
        enumeraciones,
        consecutivo: "",
        carpetadeejecucion: "",
        numeroRomano: null,
        numeroExtra: '',  
        numeroCarpeta: null, 
        fecha: null,
        fechaDevolucion: new Date().toISOString().slice(0,10),
        mostrarNumeroExtra: false,     
        parametros_PartidoJudicial: {
          key: "",
          partidoJudicialId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Materia: {
          key: "",
          materiaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Delito: {
          key: "",
          delitoId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false,
        },
        parametros_Rubro: {
          key: "",
          rubroId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false
        },
        parametros_Banco: {
          key: "",
          bancoId: 1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false
        },        
        parametros_Area: {
          key: "",
          areaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Consecutivo: {
          key: "",
          parametros: {},
          esInformativo: false
        },
        parametros_PuestoRemitente: {
        key: "",
        puestoId: 219,
        parametros: {},
         esInformativo: false
        },
        parametros_PuestoDestinatario: {
        key: "",
        puestoId: -1,
        parametros: {},
         esInformativo: false
        },
        parametros_TituloRemitente: {
        key: "",
        tituloId: 6,
        parametros: {},
         esInformativo: false
        },
        parametros_TituloDestinatario: {
        key: "",
        tituloId: 1,
        parametros: {},
         esInformativo: false
        },
        folioAcuerdo: null,
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        telefono: '449',
        monto: '',
        direccion: null,
        folioBusqueda: null,
        persona: false,
        fechasi: false,
        observacionescheck: false,
        observacionesdevolucioncheck: false,
        observaciones: null,
        observacionesdevolucion: null,
        checkJuzgadoDestinatario: false,
        fechaMaxima: new Date().toISOString().split('T')[0],
        parametros_Oficio:{
          numeroOficioJuzgado: null,
          cheque: null,
          numeroOficioOficialia: null,
          nombreRemitente: null,
          nombreDestinatario: null,
          areaDestinatarioId: null,
        }
      }
    },
    computed:{
      oficioNTamano(){
        //v-mask="oficioNTamano" //agregar en caso de que se necesite de nuevo
        if(this.parametros_Oficio.numeroOficioJuzgado == null)
          return '####X####'//return '####-####'
        return (this.parametros_Oficio.numeroOficioJuzgado.length < 10) ? '####X####' : '#####X####' 
      }
    },
    watch:{
      monto(nuevo, viejo){/////////////metodo para validar dinero con 2 decimales
        if(!nuevo){
          this.monto = ''
          return
        }
        this.monto = nuevo < 0 || nuevo > ((this.AccionesMostrar.devolver) ? (this.totalPagar-this.totalDevuelto) : Number.MAX_VALUE) ? viejo : nuevo
        nuevo += "";

        if(nuevo.includes('.') && Number(nuevo) <= Number(this.totalPagar-this.totalDevuelto).toFixed(2) 
          || (this.AccionesPago.alta && nuevo.includes('.'))//alta de pago
          || (this.AccionesMostrar.editar && nuevo.includes('.'))//editar pago
          ){
            this.monto = nuevo.split('.')[0] + '.' + nuevo.split('.')[1].slice(0,2)
        }

      },
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C006TiposRubro: catalogos.SIVAC.C006TiposRubro,
      C019TiposBanco: catalogos.SIVAC.C019TiposBanco,
      C045Puestos: catalogos.PJ.C045Puestos,
      C027TiposTitulo: catalogos.PJ.C027TiposTitulo,
    },
    props: {
      tituloDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      ejecutaLaFuncion: Function,
      filtrosEstablecidos: Object,
      cancelar: Function,

      accionCancelar: {
        default: null,
        type: Object
      },
      AccionesPago:{
        busqueda: false,
        alta: false,
        agregar: false
      },
      AccionesMostrar:{            
        firma: false,
        pagos: false,
        consulta: false, 
        guardar: false,
        buscar: false,
        editar: false ,
        devolver: false        
      },
      area: null,
      folio: null,
      rubro: null,
      banco: null,
      doc: null,
      materia: null,
      pagoID: null,
      partidoJudicial: null,
      quitarRubros: null,
      AreaId: null,
      totalDevuelto: null,
      totalPagar: null,
      puestoremitenteId:null,
      tituloremitenteId:null,
      puestodestinatarioId:null,
      titulodestinatarioId:null,
    },
    mounted() {            
      if(this.elementosAOmitir){
        if(this.elementosAOmitir.areas && this.elementosAOmitir.areas.length > 0){
          this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
          this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
        }
        if(this.elementosAOmitir.materias && this.elementosAOmitir.materias.length > 0){
          this.parametros_Materia.parametros.elementosAOmitir = this.elementosAOmitir.materias;
          this.parametros_Materia.key = "elementosOmitir_" + this.elementosAOmitir.materias.length;
        }

      }
      //$("#filtroDeBusqueda_PartidoJudicial").attr('disabled','disabled');
      
      /*this.parametros_Area.parametros.SistemaId = 38;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true; */
    },

    beforeMount()
    {
      // if(this.area == undefined && this.area == null)
      // {
      //   //this.parametros_PartidoJudicial.partidoJudicialId = 1;//para 1 partido judicial, quitar para mas
      // }
/////////////////////se agregan validaciones en caso de que sea editar
      if(this.rubro != undefined && this.rubro != null){
        this.parametros_Rubro.rubroId = this.rubro;
      }

      if(this.doc != undefined && this.doc != null){
        this.parametros_TipoDocumento.tipoDocumentoId = this.doc;
      }

      if(this.materia != undefined && this.materia != null){
        this.parametros_Materia.materiaId = this.materia;
      }
      
      if(this.AreaId != undefined && this.AreaId != null){
        this.parametros_Area.areaId = this.AreaId;
      }

      if(this.banco != undefined && this.banco != null){
        this.parametros_Banco.bancoId = this.banco;
      }
      if(this.partidoJudicial != undefined && this.partidoJudicial != null){
        this.parametros_PartidoJudicial.partidoJudicialId = this.partidoJudicial;
      }

      if(this.puestoremitenteId != undefined && this.puestoremitenteId !=null){
        this.parametros_PuestoRemitente.puestoId = this.puestoremitenteId;
      }
      if(this.tituloremitenteId != undefined && this.tituloremitenteId !=null){
        this.parametros_TituloRemitente.tituloId = this.tituloremitenteId;
      }
      if(this.puestodestinatarioId != undefined && this.puestodestinatarioId !=null){
        this.parametros_PuestoDestinatario.puestoId = this.puestodestinatarioId;
      }
      if(this.titulodestinatarioId != undefined && this.titulodestinatarioId !=null){
        this.parametros_TituloDestinatario.tituloId = this.titulodestinatarioId;
      }
///////////////////////////
      if(this.elementosAConservar){        
        if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
          this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
        }
        if(this.elementosAConservar.tiposDocumento && this.elementosAConservar.tiposDocumento.length > 0){
          this.parametros_TipoDocumento.parametros.elementosAConservar = this.elementosAConservar.tiposDocumento;
          this.parametros_TipoDocumento.key = "elementosAConservar_" + this.elementosAConservar.tiposDocumento.length;     
        }
        if(this.elementosAConservar.materias && this.elementosAConservar.materias.length > 0){
          this.parametros_Materia.parametros.elementosAConservar = this.elementosAConservar.materias;
          this.parametros_Materia.key = "elementosAConservar_" + this.elementosAConservar.materias.length;     
        }
        if(this.elementosAConservar.puestosdestinatario && this.elementosAConservar.puestosdestinatario.length > 0){
          this.parametros_PuestoDestinatario.parametros.elementosAConservar = this.elementosAConservar.puestosdestinatario;
          this.parametros_PuestoDestinatario.key = "elementosAConservar_" + this.elementosAConservar.puestosdestinatario.length;     
        }
        if(this.elementosAConservar.puestosremitente && this.elementosAConservar.puestosremitente.length > 0){
          this.parametros_PuestoRemitente.parametros.elementosAConservar = this.elementosAConservar.puestosremitente;
          this.parametros_PuestoRemitente.key = "elementosAConservar_" + this.elementosAConservar.puestosremitente.length;     
        }
      }
      //$("#filtroDeBusqueda_Area").attr('disabled','disabled');
    },
    created() {
      this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);          
    },
    methods: {           
      /**
       * Método encargado de limpiar los filtros de los combos del formulario.
       */
      limpiarFiltros: function(){
        this.parametros_PartidoJudicial.partidoJudicialId = -1;
        this.parametros_PartidoJudicial.parametros.PartidoJudicialId = -1;
        this.parametros_PartidoJudicial.parametros.AreaId = -1;
        this.parametros_PartidoJudicial.parametros.MateriaId = -1;  
                                                                               // <== descomentar si es para varios juzgados
        this.parametros_PartidoJudicial.key += 1;      

        this.parametros_Materia.materiaId = -1;//<== descomentar si es para varios juzgados
        this.parametros_Materia.parametros.PartidoJudicialId = -1;
        this.parametros_Materia.parametros.AreaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;
        this.parametros_Materia.parametros.TipoDocumentoId = -1;   //    
        this.parametros_Materia.key += 1;

        this.parametros_Area.areaId = -1;  
        this.parametros_Area.parametros.PartidoJudicialId = -1;
        this.parametros_Area.parametros.AreaId = -1;//<== descomentar si es para varios juzgados
        this.parametros_Area.parametros.MateriaId = -1;

        this.parametros_Area.key += 1;

        this.parametros_TipoDocumento.parametros.PartidoJudicialId = -1;
        this.parametros_TipoDocumento.parametros.AreaId = -1;
        this.parametros_TipoDocumento.parametros.MateriaId = -1;   

        this.parametros_TipoDocumento.parametros.elementosAConservar = [1,23,26];
        this.parametros_Area.parametros.elementosAConservar = [95, 54, 53, 48, 52, 51, 12, 56];
        this.parametros_PartidoJudicial.parametros.elementosAConservar = [1];

        this.baseDeDatosId = null;        

        this.parametros_TipoDocumento.tipoDocumentoId = -1;//<== descomentar si es para varios juzgados         
        this.parametros_TipoDocumento.key += 1;   

        this.parametros_Delito.delitoId = -1;
        this.parametros_Delito.key += 1; 

        this.parametros_Rubro.rubroId = -1;
        this.parametros_Rubro.key += 1;

        this.parametros_Banco.bancoId = -1;
        this.parametros_Banco.key += 1;

        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.consecutivo = null; 
        this.carpetadeejecucion = null;            
        this.numeroCarpeta = null; 
        this.nombre = null;
        this.apellido_paterno = null;
        this.apellido_materno = null;             
        this.esAreaDeEjecucion = false;
        this.direccion = null;
        this.telefono = '449';
        this.observaciones = null;
        this.observacionescheck = null;
        this.monto = null;

        this.folioBusqueda = null;
        //this.materia = null;
        this.fechasi = false;
        this.persona = false;
        this.numeroRomano = null;



        //$("#filtroDeBusqueda_Materia").removeAttr('disabled');
        //$("#filtroDeBusqueda_TipoDocumento").removeAttr('disabled');
        $("#Consecutivo").removeAttr('disabled');
        //$("#numeroRomano").removeAttr('disabled');
        $("#nombre").removeAttr('disabled');
        $("#apellido_paterno").removeAttr('disabled');
        $("#apellido_materno").removeAttr('disabled');
        $("#telefono").removeAttr('disabled');
        $("#observaciones").removeAttr('disabled');
        $("#persona").removeAttr('disabled');
        $("#observacionescheck").removeAttr('disabled');

        //$("#filtroDeBusqueda_Area").attr('disabled','disabled');  

        if(this.quitarRubros && this.quitarRubros.length > 0){
            $("#filtroDeBusqueda_PartidoJudicial").attr('disabled','disabled');
            $("#filtroDeBusqueda_TipoDocumento").attr('disabled','disabled');
            $("#limpiar").attr('disabled', 'disabled');
        }

      },
      /*************/
      /*Metodo para el alta de un concepto mas*/
      /*************/
      limpiarCamposAlta(){
        this.parametros_Rubro.rubroId = -1;
        this.parametros_Rubro.key += 1;

        this.monto = null;

        $("#filtroDeBusqueda_Area").attr('disabled','disabled');  
        $("#filtroDeBusqueda_PartidoJudicial").attr('disabled','disabled');
        $("#filtroDeBusqueda_Materia").attr('disabled','disabled');
        $("#filtroDeBusqueda_TipoDocumento").attr('disabled','disabled');
        $("#Consecutivo").attr('disabled','disabled');
        $("#numeroRomano").attr('disabled','disabled');
        $("#nombre").attr('disabled','disabled');
        $("#apellido_paterno").attr('disabled','disabled');
        $("#apellido_materno").attr('disabled','disabled');
        $("#telefono").attr('disabled','disabled');
        $("#observaciones").attr('disabled', 'disabled');
        $("#observacionescheck").attr('disabled', 'disabled');
        $("#persona").attr('disabled', 'disabled');
        $("#limpiar").remove();
        //console.log(quitarRubros)

      },

      fechaCheckbox(datos){
        this.fecha = datos.target.checked ? moment().format('YYYY-MM-DD') : null;

        if(this.fecha){
          this.nombre = null;
          this.apellido_paterno = null;
          this.apellido_materno = null; 
          this.folioBusqueda = null; 
        }
      },      
      /**
       * Método encargado de actualizar/cambiar el campo del Consecutivo.
       * @param {event.target} datos [datos: nuevo valor del Consecutivo]
       */
      cambioDeConsecutivo(datos) { 
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Partido Judicial
       * @param {event.target} datos [datos: nuevo valor del Partido Judicial]
       */
      cambioDePartidoJudicialEvento(datos) {
        this.cambioDePartidoJudicial(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id Partido Judicial
       * @param {int} id [id: identificador del Partido Judicial]
       */
      cambioDePartidoJudicial(id) {
        this.parametros_PartidoJudicial.partidoJudicialId = id;

        //Actualizo area
        /**/
        /**/
        this.parametros_Area.parametros.PartidoJudicialId = id;
        this.parametros_Area.key = "PartidoJudicial_" + id;        
        if (this.parametros_Area.areaId <= 0 || this.parametros_PartidoJudicial.partidoJudicialId <= 0)
          this.parametros_Area.key = "PartidoJudicial_" + id;

        //if(this.parametros_PartidoJudicial.partidoJudicialId > 0){
          //$("#filtroDeBusqueda_PartidoJudicial").attr('disabled','disabled');
        //}
        
      },            
      /**
       * Método encargado de actualizar/cambiar el campo Materia
       * @param {event.target} datos [datos: nuevo valor del Materia]
       */
      cambioDeMateriaEvento(datos) {
        this.cambioDeMateria(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Materia
       * @param {int} id [id: identificador del Materia]
       */
      cambioDeMateria(id) {
        this.parametros_Materia.materiaId = id;
        
        //Actualizo area
        this.parametros_Area.parametros.MateriaId = id;
        if (this.parametros_Area.areaId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_Area.key = "Materia_" + id;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.MateriaId = id;
        if (this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_TipoDocumento.key = "Materia_" + id;
        

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 && this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0){
            this.obtenerFiltradoTipoDeDocumentosAPI();
        }
      },
      /**
       * Método encargado de actualizar/cambiar el campo Area
       * @param {event.target} datos [datos: nuevo valor del Area]
       */
      cambioDeAreaEvento: function(datos) {
        this.cambioDeArea(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Area
       * @param {int} id [id: identificador del Area]
       */
      cambioDeArea: function(id) {
        this.parametros_Area.areaId = id;
        //Actualizo partido
        this.parametros_PartidoJudicial.parametros.AreaId = id;
        if (this.parametros_PartidoJudicial.partidoJudicialId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_PartidoJudicial.key = "Area_" + id; ///descomentar si hay mas partidos

        //Actualizo materia
        this.parametros_Materia.parametros.AreaId = id;
        /**/
        //this.parametros_Materia.materiaId = -1;///se comento para recuperar los datos a editar
        this.parametros_Materia.parametros.MateriaId = -1;    
        this.parametros_Materia.key += 1; 
        /**/        
        this.parametros_Materia.key = "Area_" + id;          

        if(this.parametros_Area.areaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
          this.esAreaDeEjecucion = true;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.AreaId = id;
        /**/
        //this.parametros_TipoDocumento.tipoDocumentoId = -1;    ///se comento para recuperar los datos a editar         
        this.parametros_TipoDocumento.key += 1;
        /**/
        this.parametros_TipoDocumento.key = "Area_" + id;

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0){

            this.obtenerFiltradoTipoDeDocumentosAPI();
        }    
              
          
        //if(this.parametros_Area.areaId > 0){
          //$("#filtroDeBusqueda_Area").attr('disabled','disabled');
        //}
      },      
      /**
       * Método encargado de actualizar/cambiar el campo Tipo de Documento
       * @param {event.target} datos [datos: nuevo valor del Tipo de Documento]
       */
      cambioDeTipoDeDocumento(datos) {
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        //Actualizo materia
        this.parametros_Materia.parametros.TipoDocumentoId = parseInt(datos.target.value);
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_TipoDocumento.tipoDocumentoId <= 0)
          this.parametros_Materia.key = "TipoDocumento_" + datos.target.value;

        //Mostramos número extra de consecutivo si es Tercería o Incidente.
        if(this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente)
          this.mostrarNumeroExtra = true;
        else
          this.mostrarNumeroExtra = false;    

      }, 
      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SIVAC.sistema.caja.pagos.ObtenerTiposDeDocumentosIdYDBId, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.MateriaId;
              this.parametros_TipoDocumento.tipoDocumentoId = respuesta.data.TiposDeDocumentosIds[0];
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },     
      /**
       * Método encargado de actualizar/cambiar el campo Delito
       * @param {event.target} datos [datos: nuevo valor del Delito]
       */
      cambioDeDelitoEvento(datos){
        this.cambioDeDelito(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Delito
       * @param {int} id [id: identificador del Delito]
       */
      cambioDeDelito(id){
        this.parametros_Delito.delitoId = id; 
      },

      /*******Rubro******/
      cambioDeRubroEvento(datos){
        this.cambioDeRubro(parseInt(datos.target.value));
      },

      cambioDeRubro(id){
        this.parametros_Rubro.rubroId = id;
      }, 
      /***********/
      /*******Banco******/
      cambioDeBancoEvento(datos){
        this.cambioDeBanco(parseInt(datos.target.value));
      },

      cambioDeBanco(id){
        this.parametros_Banco.bancoId = id;
      }, 


      //Puestos

      /**
       * Método encargado de actualizar/cambiar el campo Puesto del Remitente
       * @param {event.target} datos [datos: nuevo valor del Puesto del Remitente]
       */
      cambioDePuestoRemitenteEvento(datos) {
       this.cambioDePuestoRemitente(parseInt(datos.target.value));
      },

      /**
       * Método encargado de actualizar/cambiar el id de Puesto del Remitente
       * @param {int} id [id: identificador del Puesto del Remitente]
       */
      cambioDePuestoRemitente(id){
        this.parametros_PuestoRemitente.puestoId = id; 
      },


      /**
       * Método encargado de actualizar/cambiar el campo Puesto del Destinatario
       * @param {event.target} datos [datos: nuevo valor del Puesto del Destinatario]
       */
      cambioDePuestoDestinatarioEvento(datos) {
       this.cambioDePuestoDestinatario(parseInt(datos.target.value));
      },

      /**
       * Método encargado de actualizar/cambiar el id de Puesto del Destinatario
       * @param {int} id [id: identificador del Puesto del Destinatario]
       */
      cambioDePuestoDestinatario(id){
        this.parametros_PuestoDestinatario.puestoId = id; 
      },


      //Puestos


      //Titulos

      /**
       * Método encargado de actualizar/cambiar el campo Titulo del Remitente
       * @param {event.target} datos [datos: nuevo valor del Titulo del Remitente]
       */
      cambioDeTituloRemitenteEvento(datos) {
       this.cambioDeTituloRemitente(parseInt(datos.target.value));
      },

      /**
       * Método encargado de actualizar/cambiar el id de Titulo del Remitente
       * @param {int} id [id: identificador del Titulo del Remitente]
       */
      cambioDeTituloRemitente(id){
        this.parametros_TituloRemitente.tituloId = id; 
      },


      /**
       * Método encargado de actualizar/cambiar el campo Titulo del Destinatario
       * @param {event.target} datos [datos: nuevo valor del Titulo del Destinatario]
       */
      cambioDeTituloDestinatarioEvento(datos) {
       this.cambioDeTituloDestinatario(parseInt(datos.target.value));
      },

      /**
       * Método encargado de actualizar/cambiar el id de Titulo del Destinatario
       * @param {int} id [id: identificador del Titulo del Destinatario]
       */
      cambioDeTituloDestinatario(id){
        this.parametros_TituloDestinatario.tituloId = id; 
      },


      //Titulos


      /***********/
      /**
       * Método encargado de actualizar/cambiar el campo Numero Extra
       * @param {event.target} datos [datos: nuevo valor del Numero Extra]
       */
      cambioDeNumeroExtra(datos) {
        this.$store.dispatch("A_Comun_NumeroExtra", datos.target.value);
      },
//////////////////////////////////validaciones varias

      esNumero(datos){
        return func.esNumero(datos)
      },

      esLetra(datos){
        return func.esLetra(datos)
      },

      esLetraOficio(datos){
        return func.esLetraOficio(datos)
      },

      esNumeroOficio(datos){
        return func.esNumeroOficio(datos)
      },
      esRomano(datos){
        return func.esRomano(datos)
      },  

      esMonto(datos){
        return func.esMonto(datos)
      },

      esPortador(datos){////checa el checkbox de al portador
          if(!datos.target.checked){
            this.nombre = null;
            this.apellido_paterno = null;
            this.apellido_materno = null;
          }

          this.$emit("esAlPortador", datos.target.checked);
      },

      observacionRubro(datos){
        if(!datos.target.checked){
          this.observaciones = null;
        }
      },

      observacionDevolucion(datos){
        if(!datos.target.checked){
          this.observacionesdevolucion = null;
        }
      },
      juzgadoDestinatario(datos){
        if(datos.target.checked){
          this.parametros_Oficio.areaDestinatarioId = 95; //juzgado ejecucion
        }
        else{
          this.parametros_Oficio.areaDestinatarioId = null;
        }
      }

      /*, 
      

      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Fecha',
        'A_Comun_Consecutivo',
        'A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado',
        'A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia'
      ])*/
      
    }
  }
</script>
<style scoped>
  #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }
  ul { 
    list-style: none;
  }
  .btn-buscar{
    background-color: var(--gris-pj);
  }
/*para quitar las flechitas de monto*/

input[type='number'] {
    -moz-appearance:textfield;
}


input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
  </style>



// WEBPACK FOOTER //
// src/components/SIVAC/Comun/FiltrosDeBusqueda.vue